const a = "https://wormholescan.io/#/", o = "3.1.0", n = "c11251e36db0c93a76b9a7d39c7fcd973274f8e4", c = [
  "Ethereum",
  "Solana",
  "Arbitrum",
  "Base",
  "Sui",
  "Bsc",
  "Optimism",
  "Unichain",
  "Fantom",
  "Polygon",
  "Avalanche",
  "Celo",
  "Moonbeam",
  "Klaytn",
  "Scroll",
  "Mantle",
  "Berachain",
  "Mezo"
];
export {
  n as C,
  a as W,
  o as a,
  c as b
};
